import { createResponsesImage } from '../createResponsesImage/createResponsesImage';
import component from './ResponsesImageDeletedSvg';

export const ResponsesImageDeleted = createResponsesImage({
  name: 'ResponsesImageDeleted',
  component,
});
